var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-page-head"},[_c('h1',{staticClass:"m-page-head__title"},[_vm._v(_vm._s(_vm.title))]),(_vm.text)?_c('div',{staticClass:"m-page-head__description"},[_vm._v(_vm._s(_vm.text))]):_vm._e(),(_vm.note)?_c('div',{staticClass:"m-page-head__note"},[_vm._v(_vm._s(_vm.note))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }